import { RUNNING_VARIANTS } from "./runningTraining";
import { STRUCTURED_TRAINING_TEMPLATES } from "./trainingStructure";

// UI grouping only: structured variants keep individual_training in every payload.
export const RUNNING_TRAINING_CHOICES = [...RUNNING_VARIANTS, ...STRUCTURED_TRAINING_TEMPLATES];
export const runningChoiceLabelKey = (choice) => `${STRUCTURED_TRAINING_TEMPLATES.includes(choice) ? "trainingTemplate" : "runningVariant"}_${choice}`;
export const runningChoiceDescriptionKey = (choice) => `${STRUCTURED_TRAINING_TEMPLATES.includes(choice) ? "trainingDescription" : "runningRecommended"}_${choice}`;

export function isRunningTrainingSelection(item) {
  const unit = item?.trainingUnitType || item?.training_unit_type || item?.unitType || item?.unit_type;
  return unit === "running_training" || (unit === "individual_training" && STRUCTURED_TRAINING_TEMPLATES.includes(item?.training_template));
}

export function runningTrainingChoice(item) {
  if (!isRunningTrainingSelection(item)) return "";
  return item.training_template || item.running_variant || "";
}
